// extracted by mini-css-extract-plugin
module.exports = {"container":"ChartCarousel_container___O18c","navigationContainer":"ChartCarousel_navigationContainer__wnF3v"};